module.exports = __webpack_public_path__ + "img/hzjd1.22c98a08.jpg";